import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { XIcon } from '@pattern-library/icon';
const SearchClearIndicator = props => {
  const {
    getStyles,
    innerProps: {
      ref,
      ...restInnerProps
    }
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, restInnerProps, {
    ref: ref,
    style: getStyles('clearIndicator', props)
  }), /*#__PURE__*/React.createElement("div", {
    className: "asc-select-clear-container"
  }, /*#__PURE__*/React.createElement(XIcon, {
    className: "asc-select-clear-x",
    size: "xxs",
    color: "dark-gray",
    label: "Clear"
  }))));
};
SearchClearIndicator.propTypes = {
  innerProps: PropTypes.object,
  getStyles: PropTypes.func
};
export default SearchClearIndicator;